import { render, staticRenderFns } from "./BarangMasuk.vue?vue&type=template&id=093b79f0"
import script from "./BarangMasuk.vue?vue&type=script&lang=js"
export * from "./BarangMasuk.vue?vue&type=script&lang=js"
import style0 from "./BarangMasuk.vue?vue&type=style&index=0&id=093b79f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports